document.addEventListener('DOMContentLoaded', (e) => {
  const form = document.querySelectorAll('.js-product-form');
  function saveAllProductId() {
      let productIds = [];
      form.forEach((element) => {
          const selector = element.querySelector('select');
          const productId = element.querySelector('[name="product-id"]').value
          if (element.contains(selector)) {
              productIds.push(selector.value);
          } else {
              productIds.push(productId);
          }
      }) 
      return productIds;
  }

  form.forEach((element) => {
      element.addEventListener('submit', (event) => {
          event.preventDefault();
          const formData = new FormData(event.target);
          const data = {
              'id': parseInt(formData.get('product-id')),
              'quantity': 1
          };

          fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
          })
              .then(response => {
                  document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                      bubbles: true,
                      detail: {
                          variant: parseInt(formData.get('product-id')),
                          quantity: 1
                      }
                  }));
                  return response.json();
              })
      })
  })

  const formAll = document.querySelector('[data-action="add-all"]');
  formAll.addEventListener('submit', (event) => {
      event.preventDefault();
      const products = saveAllProductId();

      const data = { items: [] };

      products.forEach((element) => {
          data.items.push({
              'id': parseInt(element),
              'quantity': 1
          })
      })

      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
      })
          .then(response => {
              // This is just used to toogle a cart refresh. Therefore the variant used quite random.
              document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                  bubbles: true,
                  detail: {
                      variant: data.items[0].id,
                      quantity: data.items[0].quantity
                  }
              }));
          })
  });

  const carouselWrapper = document.querySelector('.main-carousel');
  new Flickity(carouselWrapper, {
      wrapAround: true,
      initialIndex: 0,
      contain: true
  })
});